import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { IMMUNIZATIONS_QUERY_KEY } from "./useImmunizationsQuery";


export const useImmunizationsPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "pcmedapi",
        path: "/immunizations",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [IMMUNIZATIONS_QUERY_KEY] });
    },
  });
};

export const useImmunizationsPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "pcmedapi",
        path: "/immunizations",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey:[IMMUNIZATIONS_QUERY_KEY] });
    },
  });
};

export const useImmunizationsDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "pcmedapi",
        path:"/immunizations",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [IMMUNIZATIONS_QUERY_KEY] });
    },
  });
};
